import { Fragment } from 'react';

const Repeat = (props) => {
  const { children, times = 1, max = 100 } = props;

  let t = times;

  if (!Number.isFinite(times) || times < 1 || times > max) {
    console.warn(
      '[Repeat]: "times" not a valid number, or "max" limit has been riched. [1] used instead.',
    );
    t = times > max ? max : 1;
  }
  return (
    <>
      {new Array(t).fill(null).map((v, i) => (
        <Fragment key={i}>{children}</Fragment>
      ))}
    </>
  );
};

export default Repeat;
